export default __webpack_public_path__ + "static/media/barak-10.7a0391a3.jpeg";